import * as Sentry from '@sentry/react';

const dsn = document.querySelector('meta[name="sentry-dsn"]')?.content;
const railsEnv = document.querySelector('meta[name="rails-env"]')?.content;

const enabled = railsEnv === 'production' && !!dsn;

if (enabled) {
  Sentry.init({
    dsn,
    environment: railsEnv,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 0.25,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

export function reportError(error, errorInfo) {
  if (!enabled) return;
  Sentry.captureException(error, {
    contexts: errorInfo ? { react: { componentStack: errorInfo.componentStack } } : undefined,
  });
}
